import React from "react";

const Contact: React.FC = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Jak nás kontaktovat</h1>
      <p>
        Pokud máte své zkušenosti, dobré, či špatné, můžete se s námi o ně podělit na: <a href="mailto:zachranmezelvy@proton.me">zachranmezelvy@proton.me</a>.
      </p>
      <p>
        Přiložte, prosím, nějaký dokument ověřující vaše vlastnictví želvy. Ideálně scan registračního formuláře.
      </p>
      <p>
        V případě, že chcete sdílet pozitivní zkušenost, vyčkejte až budete mít želvu minimálně rok a nechte ji před tím skontrolovat veterinářem.
      </p>
      <p>
        Pro negativí zkušenost bude ideální když dodáte zprávu od veterináře, nebo cokoli co bude vaše tvtrzení podporovat.
      </p>
      <p>
        Pokud chcete aby váš příběh nebyl zveřejněn, dejte to, prosím, najevo v emailu. Kazdý zveřejněný příběh bude samozřejmě bez osobních údajů. Ta budou sloužit pouze pro ověření na naší straně.
      </p>
    </div>
  );
};

export default Contact;